import { useDispatch, useSelector } from 'react-redux';
import { SLIButton } from '../buttons/SLIButton';
import { ExpandingDropdown } from '../misc/ExpandingDropdown';
import { SelectionList } from '../misc/SelectionList';
import { Slider } from '../misc/Slider';
import { CalendarDialog } from '../CalendarDialog';
import { filterEquipmentWithDateRange } from '../../redux/slices/equipmentsSlice';
import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getEquipmentTranslation } from '../../utils/equipmentTranslation';

// TODO: this needs to be reconciled with EquipmentFilter
const FarmshareFilterComponent = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;
  const dispatch = useDispatch();
  const equipments = useSelector((state) => state.equipments.equipments);
  const loading = useSelector((state) => state.equipments.loading);
  const [filters, setFilters] = useState({});
  const [dateRange, setDateRange] = useState(null);

  const [locations, types, maxPrice] = useMemo(() => {
    const uniqueLocations = new Set();
    const uniqueTypes = new Set();
    let tempMaxPrice = 0;
    equipments.forEach((equipment) => {
      if (equipment.location) {
        uniqueLocations.add(equipment.location);
      }
      if (equipment.type) {
        // Get translated type for display
        const translatedType = getEquipmentTranslation(equipment, 'type', currentLang);
        uniqueTypes.add(translatedType);
      }
      if (equipment.rentalPrice > tempMaxPrice) {
        tempMaxPrice = equipment.rentalPrice;
      }
    });
    return [Array.from(uniqueLocations).sort(), Array.from(uniqueTypes).sort(), tempMaxPrice];
  }, [equipments, currentLang]);

  console.log(maxPrice);

  const setFilter = (key) => (value) => {
    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // TODO: Implement an on select

  const handleFindEquipment = () => {
    // Dispatch the new async thunk that includes real reservation checking
    dispatch(filterEquipmentWithDateRange({ ...filters, dateRange }));
  };

  useEffect(() => {
    console.log('Filters updated:', filters);
  }, [filters]);

  useEffect(() => {
    console.log('Date range updated:', dateRange);
  }, [dateRange]);

  const sortOptions = [
    t('farmshareInProgress.filterComponent.lowToHigh'),
    t('farmshareInProgress.filterComponent.highToLow'),
  ];

  return (
    <div className="flex flex-col gap-4 p-8 w-full border-2 border-SLIGreen-20 bg-SLIGreen1-50 rounded-3xl">
      <span className="text-2xl font-medium">
        {t('farmshareInProgress.filterComponent.filterBy')}
      </span>
      <span className="text-md font-medium">
        {t('farmshareInProgress.filterComponent.priceRange')}
      </span>
      {/* TODO: Implement the range based on returned equipment from API */}
      {maxPrice !== 0 && (
        <Slider min={0} max={maxPrice} minRangeGap={10} onValuesChange={setFilter('priceRange')} />
      )}
      <div className="flex flex-col">
        <span className="text-md font-medium">
          {t('farmshareInProgress.filterComponent.availability')}
        </span>
        <div className="mt-2">
          <CalendarDialog value={dateRange} onChange={setDateRange} equipmentId={null} />
        </div>
      </div>
      {dateRange && (
        <div className="mt-2 flex justify-between text-md font-medium">
          <div className="flex flex-col">
            <span className="text-SLIGreen">Start</span>
            <span className="text-SLIBlack">
              {dateRange.from ? dateRange.from.toLocaleDateString() : 'N/A'}
            </span>
          </div>
          <div className="flex flex-col">
            <span className="text-SLIGreen">End</span>
            <span className="text-SLIBlack">
              {dateRange.to ? dateRange.to.toLocaleDateString() : 'N/A'}
            </span>
          </div>
        </div>
      )}
      {/* TODO: Implement the options based on returned equipment from API */}
      <ExpandingDropdown label={t('farmshareInProgress.filterComponent.location')} indent>
        <SelectionList options={locations} onSelectionChange={setFilter('locationOptions')} />
      </ExpandingDropdown>
      <ExpandingDropdown label={t('farmshareInProgress.filterComponent.equipmentType')} indent>
        <SelectionList options={types} onSelectionChange={setFilter('equipmentTypeOptions')} />
      </ExpandingDropdown>
      <hr className="border-0 my-2 h-[2px] bg-SLIGreen-20" />
      <span className="text-2xl font-medium">
        {t('farmshareInProgress.filterComponent.sortBy')}
      </span>
      <span className="text-md font-medium">{t('farmshareInProgress.filterComponent.price')}</span>
      <SelectionList options={sortOptions} exclusive onSelectionChange={setFilter('priceSort')} />
      <SLIButton
        label={
          loading
            ? t('farmshareInProgress.filterComponent.filtering')
            : t('farmshareInProgress.filterComponent.findEquipment')
        }
        onClick={() => {
          handleFindEquipment();
        }}
        className="px-3 mt-2"
        disabled={loading}
      />
    </div>
  );
};

export { FarmshareFilterComponent };
